import { render } from "./ChallengeOverview.vue?vue&type=template&id=d3542608&scoped=true"
import script from "./ChallengeOverview.vue?vue&type=script&lang=js"
export * from "./ChallengeOverview.vue?vue&type=script&lang=js"

import "./ChallengeOverview.vue?vue&type=style&index=0&id=d3542608&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3542608"],['__file',"src/components/ChallengeOverview.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d3542608"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d3542608', __exports__)) {
    api.reload('d3542608', __exports__)
  }
  
  module.hot.accept("./ChallengeOverview.vue?vue&type=template&id=d3542608&scoped=true", () => {
    api.rerender('d3542608', render)
  })

}


export default __exports__